import React, { memo, useState, useEffect, useCallback } from "react";
import Empty from "../../../empty";
import { getNewsData, getWeather } from "@/api/home";
import { FocusSDK } from "@/utils";
import styles from "./style.module.less";
import { HomeOssUrl as CDN_URL } from "@/components/Home/utils";
import { weatherImagePath } from "./util";
import { Iprops } from "../..";
const arrow = `${CDN_URL}/right.png`;
export interface weatherItem {
  week: string;
  date: string;
  districtName: string;
  weather: string;
  tempRange: string;
}
export interface HotItem {
  setting: {
    // 模块信息
    moduleName: string;
  };
  content: {
    // 热点信息
    title: string;
    pcUrl: string;
    mobileUrl: string;
  };
}
const Weather = ({ onAppOrLinkClick }: Iprops) => {
  const [infoData, setInfoData] = useState<weatherItem | null>(null);
  const [newsData, setNewsData] = useState<HotItem | null>(null);
  useEffect(() => {
    getWeather()
      .then((res: weatherItem) => {
        setInfoData(res);
      })
      .catch((e) => {
        console.log("e", e);
      });
    getNewsData()
      .then((res: HotItem) => {
        // 获取banner设置
        console.log(res, "resgetNewsData");
        setNewsData(res);
      })
      .catch((e) => {
        console.log("e", e);
      });
  }, []);
  const onClick = useCallback(() => {
    if (newsData?.content?.pcUrl) {
      onAppOrLinkClick({ ...newsData?.content, urlType: 1 });
    }
  }, [newsData]);
  return (
    <div className={styles.wrapper} onClick={onClick}>
      {infoData ? (
        <div className={styles.cnt_col6}>
          <div className={styles.icon_space}>
            <img className={styles.icon} src={CDN_URL + "/news-pc.png"} />
          </div>
          <div className={styles.line2}>{newsData?.content?.title}</div>
          <img src={arrow} className={styles.icon1} />
          <div className={styles.cnt_row10}>
            <img className={styles.weather_bg} src={weatherImagePath(infoData.weather)} />
            <span className={styles.txt5}>{infoData.date}</span>
            <span className={styles.txt6}>{infoData.week}</span>
            <span className={styles.txt7}>{infoData.weather}</span>
            <span className={styles.txt8}>{infoData.tempRange}</span>
          </div>
        </div>
      ) : (
        <Empty />
      )}
    </div>
  );
};

export default Weather;
